<template>
    <v-navigation-drawer
        v-model="drawer"          
        width="900"
        app
        temporary
        right
        class="wost-drawer"
    >
        <div class="form-head">
            {{ titleForm }}
        </div>
        <div class="pl-3 pt-3 pr-3">
            <v-card>
                <v-card-text v-if="customerSelected" class="pt-0 pb-0">
                    <template>
                        <v-row>
                            <v-col cols="6">
                                <span v-if="customerSelected.type_document === 'DNI'" class="title">
                                    {{ customerSelected.name }} {{ customerSelected.surname }}
                                </span>
                                <span v-else class="title">{{ customerSelected.name }}</span>
                                <span class="d-block">
                                    {{ customerSelected.type_document }}
                                    {{ customerSelected.document }}
                                </span>
                            </v-col>
                            <v-col cols="6">
                                
                            </v-col>
                        </v-row>
                    </template>
                </v-card-text>                
            </v-card>

            <v-card class="mt-3">
                <v-data-table
                    class="wost-table"
                    :headers="headers"
                    :items="debtsCustomer"
                    hide-default-footer
                    item-key="id"
                    height="70vh"
                    no-data-text=""
                    show-expand
                    :single-expand="true"
                >
                    <template v-slot:item.order_id="{ item }">
                        #{{ item.order_id | numberOrder }}
                    </template>
                    <template v-slot:item.entry_date="{ item }">
                        {{ item.entry_date | moment("DD/MM/YYYY, h:mm a") }}
                    </template>                                    
                    <template v-slot:item.amount="{ item }">
                        {{ item.amount | currency('S/ ') }}
                    </template>
                    <template v-slot:item.amount_paid="{ item }">
                        {{ item.amount_paid | currency('S/ ') }}
                    </template>
                    <template v-slot:item.amount_pending="{ item }">
                        {{ item.amount_pending | currency('S/ ') }}
                    </template>
                    <template v-slot:item.status="{ item }">
                        <span v-if="item.status == 'pendiente'" class="text-red">{{ item.status | capitalize }}</span>
                        <span v-else class="text-green">{{ item.status | capitalize }}</span>
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-btn small 
                            v-if="item.amount_pending > 0 && verifyPermission('registrar_pago_deudas')" color="primary" 
                            @click="handlePayDebt(item)"> 
                            Pagar
                        </v-btn>
                    </template>
                    <template v-slot:expanded-item="{ item, headers }">
                        <td :colspan="headers.length" class="wost-td-expanded">
                            <template>
                                <v-container>
                                    <v-row justify="center">
                                        <v-col cols="10" class="pt-0 pb-0">
                                            <span class="font-weight-medium caption">Detalle de pagos</span>
                                        </v-col>
                                    </v-row>
                                    <v-row justify="center">
                                        <v-col cols="10" class="pt-0 pb-0">
                                            <v-simple-table dense>
                                                <thead>
                                                    <tr>
                                                        <th>Fecha y Hora de pago</th>
                                                        <th>Monto Pagado</th>
                                                        <th>Observaciones</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="payment in item.payments" :key="payment.id">
                                                        <td>{{ payment.payment_date  | moment("DD/MM/YYYY, h:mm a") }}</td>
                                                        <td>{{ payment.amount_payment | currency('S/') }}</td>
                                                        <td>{{ payment.observaciones}}</td>
                                                    </tr>
                                                </tbody>
                                            </v-simple-table>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </template>                            
                        </td>
                    </template>
                </v-data-table>
            </v-card>
        </div>
        <pay-debt ref="payDebt"></pay-debt>
    </v-navigation-drawer>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

import PayDebt from './PayDebt'

export default {
    name: 'DebtDetail',
    components: {
        PayDebt
    },
    data() {
        return {
            titleForm: '',
            drawer: false,
            headers: [
                { text: '', value: 'data-table-expand', width: 5, class: 'header-table-expand' },
                { text: 'Nro Pedido', value: 'order_id', align: 'left', sortable: false, class: 'header-table'},
                { text: 'Fecha Deuda', value: 'entry_date', align: 'left', sortable: false, class: 'header-table'},               
                { text: 'Monto', value: 'amount', align: 'left', sortable: false, class: 'header-table', width: 100 },
                { text: 'Pagado', value: 'amount_paid', align: 'left', sortable: false, class: 'header-table', width: 100},
                { text: 'Pendiente', value: 'amount_pending', align: 'a-right', sortable: false, class: 'header-table', width: 100},
                { text: 'Estado', value: 'status', align: 'center', sortable: false, class: 'header-table', width: 100},
                { text: 'Acciones', value: 'action', sortable: false, class: 'header-table', width: 35 }
            ]
        }
    },
    computed: {
        ...mapState('cash', [
            'cashCurrent'
        ]),
        ...mapState('debts', [
            'customerSelected',
            'debtsCustomer',
            'selectedDebt'
        ])
    },
    methods:{
        ...mapActions('cash', [
            'getCashCurrent'
        ]),
        ...mapActions('debts', [
            'runSetSelectedDebt'
        ]),
        showForm(title) {
            this.titleForm = title
            this.drawer = !this.drawer
        },
        handlePayDebt(debt){
            if (this.cashCurrent == null || this.cashCurrent == '') {
                this.$swal({
                    text: "Caja esta cerrada, no puede realizar pago.",
                    icon: "warning",
                    showCancelButton: false,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Aceptar"
                });
            } else {
                this.runSetSelectedDebt(null)
                this.runSetSelectedDebt(debt)
                this.$refs.payDebt.showForm('Registrar Pago')
            }
        },
        verifyPermission(permission) {
            return this.$hasPermision(permission)
        }
    }
}
</script>

<style>
.debt-header-payment > tr > th {
    background-color: #3F51B5;
    color: #ffffff !important;
    height: 30px !important;
}
</style>